import { getImages } from '../services/napi';
import { IMAGE_FETCH_SUCCESS, IMAGE_FETCH_FAIL } from '../constant/actionType';

function fetchImagesSuccess(data) {
  return { data, type: IMAGE_FETCH_SUCCESS };
}

function fetchImagesError() {
  return {
    error: 'FILES_FETCH_FAIL',
    type: IMAGE_FETCH_FAIL
  };
}

export function fetchImages() {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;

      const response = await getImages(projectId);

      dispatch(fetchImagesSuccess(response.data));
    } catch (error) {
      dispatch(fetchImagesError());
    }
  };
}
